import { axios } from '@/utils/request'

export default {
    createClass(input){
        return axios.post('/api/services/app/Class/CreateClass',input)
    },
    updateClass(input){
        return axios.put('/api/services/app/Class/UpdateClass',input)
    },
    deleteClass(id){
        return axios.delete('/api/services/app/Class/DeleteClass?Id='+id)
    },
    getClass(id){
        return axios.get('/api/services/app/Class/GetClass?Id='+id)
    },
    getClassList(page){
        return axios.get('/api/services/app/Class/GetClassList',{params:page})
    },
    getSchools(){
        return axios.get('/api/services/app/Class/GetSchools')
    },
    getLessons(){
        return axios.get('/api/services/app/Class/GetLessons')
    },
    getRoomForClass(input){
        return axios.get('/api/services/app/Class/GetRoomForClass',{params:input})
    },
    getTeacherForClass(input){
        return axios.get('/api/services/app/Class/GetTeacherForClass',{params:input})
    },
    closeClass(input){
        return axios.post('/api/services/app/Class/CloseClass',input)
    },
    deleteStudent(id){
        return axios.delete('/api/services/app/Class/DeleteStudent?Id='+id)
    },
    recordLesson(input){
        return axios.post('/api/services/app/Class/RecordLesson',input)
    },
    getSchedulerItems(input){
        return axios.get('/api/services/app/Class/GetSchedulerItems',{params:input})
    },
    finishClassTeam(input){
        return axios.post('/api/services/app/Class/FinishClassTeam',input)
    },
    createTeam(input){
        return axios.post('/api/services/app/Class/CreateTeam',input)
    },
    getTeacherForTeam(input){
        return axios.get('/api/services/app/Class/GetTeacherForTeam',{params:input})
    },
    changeTeacher(input){
        return axios.post('/api/services/app/Class/ChangeTeacher',input)
    },
    deposit(input){
        return axios.post('/api/services/app/Class/Deposit',input)
    },
    getTransClassTeam(input){
        return axios.get('/api/services/app/Class/GetTransClassTeam',{params:input})
    },
    transClassTeam(input){
        return axios.post('/api/services/app/Class/TransClassTeam',input)
    },
    updateClassTeamInfo(input){
        return axios.put('/api/services/app/Class/UpdateClassTeamInfo',input)
    }
}